import { asyncThunkWrapper } from "../utils/asyncThunkWrapper";
import { serviceNames } from "../utils/constants";
import { getService } from "./service";

const initialState = {
  tags: [],
  loading: false,
  error: null,
  total: 0,
};

// Action Types
const FETCH_TAGS_REQUEST = "FETCH_TAGS_REQUEST";
const FETCH_TAGS_SUCCESS = "FETCH_TAGS_SUCCESS";
const FETCH_TAGS_FAILURE = "FETCH_TAGS_FAILURE";
const CREATE_TAG_REQUEST = "CREATE_TAG_REQUEST";
const CREATE_TAG_SUCCESS = "CREATE_TAG_SUCCESS";
const CREATE_TAG_FAILURE = "CREATE_TAG_FAILURE";
const UPDATE_TAG_REQUEST = "UPDATE_TAG_REQUEST";
const UPDATE_TAG_SUCCESS = "UPDATE_TAG_SUCCESS";
const UPDATE_TAG_FAILURE = "UPDATE_TAG_FAILURE";
const DELETE_TAG_REQUEST = "DELETE_TAG_REQUEST";
const DELETE_TAG_SUCCESS = "DELETE_TAG_SUCCESS";
const DELETE_TAG_FAILURE = "DELETE_TAG_FAILURE";

// Async Actions using asyncThunkWrapper

export const getTags =
  (page = 0, pageSize = 5, sortField = "code", sortDirection = "asc") =>
  async (dispatch) => {
    const service = getService(serviceNames.codePerTags);
    const query = {
      $limit: pageSize,
      $skip: page * pageSize,
      $sort: { [sortField]: sortDirection === "asc" ? 1 : -1 },
      isDeleted: false,
    };

    return await asyncThunkWrapper({
      dispatch,
      types: {
        request: FETCH_TAGS_REQUEST,
        success: FETCH_TAGS_SUCCESS,
        failure: FETCH_TAGS_FAILURE,
      },
      apiCall: () => service.find({ query }),
      transformResult: (result) => ({
        tags: result.data,
        total: result.total,
      }),
      errorMessagePrefix: "Failed to fetch tags",
    });
  };

export const createTag = (tagData) => async (dispatch) => {
  const service = getService(serviceNames.codePerTags);
  return await asyncThunkWrapper({
    dispatch,
    types: {
      request: CREATE_TAG_REQUEST,
      success: CREATE_TAG_SUCCESS,
      failure: CREATE_TAG_FAILURE,
    },
    apiCall: () => service.create(tagData),
    successMessage: "Tag created successfully",
    errorMessagePrefix: "Failed to create tag",
  });
};

export const updateTag = (code, tagData) => async (dispatch) => {
  const service = getService(serviceNames.codePerTags);
  return await asyncThunkWrapper({
    dispatch,
    types: {
      request: UPDATE_TAG_REQUEST,
      success: UPDATE_TAG_SUCCESS,
      failure: UPDATE_TAG_FAILURE,
    },
    apiCall: () => service.patch(code, tagData),
    successMessage: "Tag updated successfully",
    errorMessagePrefix: "Failed to update tag",
  });
};

export const deleteTag = (code, userId) => async (dispatch) => {
  const service = getService(serviceNames.codePerTags);
  const patchData = {
    isDeleted: true,
    deletedBy: userId,
    deletedAt: new Date().toISOString(),
  };

  return await asyncThunkWrapper({
    dispatch,
    types: {
      request: DELETE_TAG_REQUEST,
      success: DELETE_TAG_SUCCESS,
      failure: DELETE_TAG_FAILURE,
    },
    apiCall: () => service.patch(code, patchData),
    transformResult: () => code,
    successMessage: "Tag deleted successfully",
    errorMessagePrefix: "Failed to delete tag",
  });
};

// Reducer

export default function codePerTagsReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_TAGS_REQUEST:
    case CREATE_TAG_REQUEST:
    case UPDATE_TAG_REQUEST:
    case DELETE_TAG_REQUEST:
      return { ...state, loading: true, error: null };

    case FETCH_TAGS_SUCCESS:
      return {
        ...state,
        loading: false,
        tags: action.payload.tags,
        total: action.payload.total,
      };

    case CREATE_TAG_SUCCESS:
      return {
        ...state,
        loading: false,
        tags: [...state.tags, action.payload],
        total: state.total + 1,
      };

    case UPDATE_TAG_SUCCESS:
      return {
        ...state,
        loading: false,
        tags: state.tags.map((tag) =>
          tag.code === action.payload.code ? action.payload : tag
        ),
      };

    case DELETE_TAG_SUCCESS:
      return {
        ...state,
        loading: false,
        tags: state.tags.filter((tag) => tag.code !== action.payload),
        total: state.total - 1,
      };

    case FETCH_TAGS_FAILURE:
    case CREATE_TAG_FAILURE:
    case UPDATE_TAG_FAILURE:
    case DELETE_TAG_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
}
